var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hall-seat",class:{'reserved' : !_vm.isFree, 'selected': _vm.checkIsSelected},style:('grid-row:' + _vm.row + '; grid-column:' + _vm.col + ';'),on:{"click":_vm.onSelectSeat}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1324297c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/Seats/HallSeat.vue
// module id = null
// module chunks = 